import React from "react";

const AutocompleteItem = ({ image, name, addon }) => {
  return (
    <div className="autocomplete-item">
      {image && <div className="autocomplete-item__image">{image}</div>}
      <div className="autocomplete-item__name">
        {name}
        {addon && <div className="autocomplete-item__addon">{addon}</div>}
      </div>
    </div>
  );
};

export default AutocompleteItem;
